/** Chaves técnicas de `aditional_info` que não devem aparecer como texto livre na UI */
export const ADITIONAL_INFO_SKIP_KEYS = new Set(['integration_history']);

/**
 * Campo costuma vir no Applicant; em alguns payloads vem apenas em Person.
 * @param {Object} applicant - Objeto Applicant, pode ser null ou undefined
 * @returns {string|null} - Retorna o valor bruto de `aditional_info` ou null se não encontrado
 */
export function getApplicantAditionalInfoRaw(applicant) {
  if (!applicant) return null;

  if (applicant.aditional_info != null && applicant.aditional_info !== '') {
    return applicant.aditional_info;
  }

  if (
    applicant.person &&
    applicant.person.aditional_info != null &&
    applicant.person.aditional_info !== ''
  ) {
    return applicant.person.aditional_info;
  }

  return null;
}

/**
 * Dado um objeto parseado de `aditional_info`, retorna uma lista de pares [chave, valor] filtrados e formatados para exibição. Chaves em `ADITIONAL_INFO_SKIP_KEYS` são ignoradas. Valores nulos, indefinidos, objetos ou strings vazias são ignorados. Valores booleanos são convertidos para "Yes"/"No" usando mensagens internacionalizadas.
 * @param {Object} parsed - Objeto parseado de `aditional_info`
 * @param {Object} intl - Objeto de internacionalização para formatar mensagens
 * @returns {Array} - Retorna uma lista de pares [chave, valor] prontos para exibição
 */
export function getAditionalInfoDisplayEntries(parsed, intl) {
  const entries = [];

  for (const [key, value] of Object.entries(parsed)) {
    if (ADITIONAL_INFO_SKIP_KEYS.has(key)) continue;

    if (value === null || value === undefined) continue;

    if (typeof value === 'object') continue;

    let strVal;
    if (typeof value === 'boolean') {
      strVal = value
        ? intl.formatMessage({
            id: 'Common.aditionalInfoValueYes',
            defaultMessage: 'Yes'
          })
        : intl.formatMessage({
            id: 'Common.aditionalInfoValueNo',
            defaultMessage: 'No'
          });
    } else {
      strVal = String(value);
    }

    const trimmed = strVal.trim();
    if (!trimmed) continue;

    entries.push([key, trimmed]);
  }

  entries.sort((a, b) => a[0].localeCompare(b[0], undefined, { sensitivity: 'base' }));

  return entries;
}

/** Converte uma chave de `aditional_info` de snake_case para uma forma mais legível, substituindo underscores por espaços e capitalizando as palavras. Exemplo: "has_portfolio" -> "Has Portfolio".
 * @param {string} key - Chave original de `aditional_info`
 * @returns {string} - Chave formatada para exibição
 */
export function humanizeAditionalInfoKey(key) {
  return key.replace(/_/g, ' ').replace(/^\w|\s\w/g, (m) => m.toUpperCase());
}
